import React from "react";
import { ReactComponent as PhoneCallIcon } from "./Icons/phoneCall.svg";
import { ReactComponent as EmailIcon } from "./Icons/email.svg";
import { ReactComponent as CreditsIcon } from "./Icons/monthlyCredits.svg";

/*
 * The header now carries only what belongs to the current session: credits,
 * notifications, and the two compose actions. Pricing, onboarding and Request
 * Demo moved to the right rail -- they are about the product rather than the
 * page, and the header was crowded enough that they were the first things to
 * be dropped whenever the drawer opened.
 */

// Rendered first, on its own, because it carries a count and its own popup.
const creditsIcon = {
  name: "creditsUsage",
  icon: <CreditsIcon />,
  title: "Monthly data credits",
  custom: true,
  featureTitle: "CREDITS"
};

// Compose actions, rendered after notifications.
const actionIcons = [
  {
    name: "phoneCall",
    icon: <PhoneCallIcon />,
    title: "Make a call",
    featureTitle: "PHONE"
  },
  {
    name: "email",
    icon: <EmailIcon />,
    title: "Send Email",
    featureTitle: "EMAIL"
  }
];

// Kept for anything still importing the flat list.
const iconList = [creditsIcon, ...actionIcons];

export { iconList, creditsIcon, actionIcons };
